<script>
  import ReceiptDivider from './ReceiptDivider.svelte';

  let {
    items = [],
    total,
    currency = '₩',
  } = $props();

  function formatAmount(amount) {
    return amount.toLocaleString();
  }
</script>

<div class="receipt-summary">
  <ReceiptDivider variant="dashed" spacing="sm" />

  <div class="receipt-summary__items">
    {#each items as item}
      <div
        class="receipt-summary__row"
        class:receipt-summary__row--excluded={item.excluded}
        class:receipt-summary__row--highlight={item.highlight}
      >
        <span class="receipt-summary__label">{item.label}</span>
        <span class="receipt-summary__amount">
          {currency}{formatAmount(item.amount)}
        </span>
      </div>
    {/each}
  </div>

  <ReceiptDivider variant="double" spacing="sm" />

  <div class="receipt-summary__total">
    <span class="receipt-summary__total-label">{total.label}</span>
    <span class="receipt-summary__total-amount">
      {currency}{formatAmount(total.amount)}
    </span>
  </div>
</div>

<style>
  .receipt-summary {
    width: 100%;
  }

  .receipt-summary__items {
    display: flex;
    flex-direction: column;
    gap: var(--receipt-item-gap, 6px);
    padding: 4px 0;
  }

  .receipt-summary__row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    font-family: var(--font-mono);
    font-size: var(--receipt-size-body, 13px);
    color: var(--receipt-text-primary);
    line-height: 1.6;
  }

  .receipt-summary__row--excluded {
    color: var(--receipt-text-excluded, #FF3B30);
  }

  .receipt-summary__row--excluded .receipt-summary__amount {
    text-decoration: line-through;
  }

  .receipt-summary__row--highlight {
    color: var(--receipt-text-accent, #20B2AA);
  }

  .receipt-summary__label {
    letter-spacing: 0.5px;
  }

  .receipt-summary__amount {
    font-variant-numeric: tabular-nums;
    letter-spacing: var(--receipt-ls-amount, 0.5px);
    white-space: nowrap;
  }

  .receipt-summary__total {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    font-family: var(--font-mono);
    padding: 4px 0;
  }

  .receipt-summary__total-label {
    font-size: 18px;
    font-weight: 700;
    color: var(--receipt-text-accent, #20B2AA);
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .receipt-summary__total-amount {
    font-size: 18px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    letter-spacing: var(--receipt-ls-amount, 0.5px);
    color: var(--receipt-text-accent, #20B2AA);
    white-space: nowrap;
  }
</style>
